// eslint-disable-next-line @github-ui/github-monorepo/filename-convention, import/no-namespace
import * as Data from './../../data'

// List of announcement IDs that use WebGL animations
export const WEBGL_SCENE_IDS: Array<keyof typeof Data> = []

// List of announcement IDs that use DOM animations
export const DOM_ANIMATION_IDS: Array<keyof typeof Data> = []
